import { useState } from 'react'
import { MessageSquarePlus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/use-auth'
import { NewRequestModal } from './new-request-modal'

/** Floating "report an issue" button, tawk.io-style — fixed bottom-right, open everywhere in the
 * authenticated portal so submitting a service request never requires hunting for the Requests
 * page. `bottom-20` clears the mobile bottom nav (h-16); desktop has no bottom nav to clear. */
export function RequestFab() {
  const [open, setOpen] = useState(false)
  const { user } = useAuth()

  if (user?.featureAccess.service_requests === false) return null

  return (
    <>
      <Button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Report an issue"
        title="Report an issue"
        className="fixed right-6 bottom-20 z-40 h-14 w-14 rounded-full p-0 shadow-lg lg:bottom-6"
      >
        <MessageSquarePlus size={24} strokeWidth={1.75} />
      </Button>
      {open && <NewRequestModal onClose={() => setOpen(false)} />}
    </>
  )
}
